import { DOC_FLOW_FORM_FIELD_TYPE } from '../DocFlow.constants'

export function getDocFlowChangeTypeValue(values) {
  return {
    [DOC_FLOW_FORM_FIELD_TYPE]: values[DOC_FLOW_FORM_FIELD_TYPE].value,
  }
}
